import React, { useCallback } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

export const Translated = ({ id, values = {} }) => (
  <FormattedMessage id={id} defaultMessage={id} values={{
    b: (text) => <b>{text}</b>,
    i: (text) => <i>{text}</i>,
    br: <br />,
    ...values,
  }} />
);

export const useTranslated = () => {
  const intl = useIntl();

  return useCallback((id, values) => {
    return intl.formatMessage({ id, defaultMessage: id }, {
      b: (text) => <b>{text}</b>,
      i: (text) => <i>{text}</i>,
      br: <br />,
      ...values,
    });
  }, [intl]);
};
